






















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { CreateAnnouncement,UpdateAnnouncement} from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander } from '@/components/table'
import { VImageUpload } from '@/components/upload'
import { TxLocal } from '@/utils/local/TxLocal'
import FileUpload from '@/utils/fileupload/fileUpload'
import 'mavon-editor/dist/css/index.css'
import mavonEditor from 'mavon-editor'

const me = mavonEditor.mavonEditor

@Component({
  components: {
    VTable,
    VImageUpload,
    me,
  },
})
export default class EditShopDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.data = {
 
    }
    this.show = false
  }
  private data: any = {
 
  }
  private fileUpload = new FileUpload()

  private show = false
  private isEdit = false

  private change(value: any, render: any) {
    this.data.contentHtml = render
  }

  private async addImage(fileIndex: any, File: any){
    console.log('addImgToMd', fileIndex, File);

    const fr = await this.fileUpload.fileUpload(File)
    const md = this.$refs['md'] as any
    md.$img2Url(fileIndex, fr.url)
  }


  public async open(data: any, isEdit: boolean) {
    this.show = true
    this.data = {...this.data,...data}
    this.isEdit = isEdit
  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    name: [this.requiredRule],
    icon: [this.requiredRule],
    isDemotion: [this.requiredRule],
    contributionNumber: [this.requiredRule],
    sequence: [this.requiredRule],
    level: [this.requiredRule],
  }

  public async save() {

    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
        console.log(this.data)
        let result = {}
        if(this.isEdit){
          result = await UpdateAnnouncement(this.data)
        } else {
          result = await CreateAnnouncement(this.data)
        }
        if(result){
          this.close()
        }

      } else {
        this.$message.error("表单存在错误，不能保存")
        return false
      }
    })
  }
}
